import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Select } from 'antd'
import { MeetingType } from '../../../types'
import { MeetingTag } from '../MeetingTag'

const { Option } = Select

interface Props {
  inviteOptions: MeetingType[]
  onChangeMeetingType: (type: MeetingType) => void
  meetingType: MeetingType
  isPredefined?: boolean
  shouldDisableAppraisals?: boolean
}

export const MeetingInviteOptionsSelect: FC<Props> = ({
  inviteOptions,
  onChangeMeetingType,
  meetingType,
  isPredefined = false,
  shouldDisableAppraisals = false,
}) => {
  const [t] = useTranslation()
  return (
    <>
      {isPredefined ? (
        <MeetingTag type={meetingType} />
      ) : (
        <>
          <Select
            onChange={(value: MeetingType) => onChangeMeetingType(value)}
            value={t(`meetingTypes.${meetingType}`)}
            defaultValue={t(`meetingTypes.${meetingType}`)}
            style={{ width: '200px' }}
            data-e2e-invite-options-select
          >
            {[...inviteOptions]
              .sort((a, b) => t(`meetingTypes.${a}`).localeCompare(t(`meetingTypes.${b}`)))
              .map((meetingOption) => {
                return (
                  <Option
                    key={meetingOption}
                    value={meetingOption}
                    disabled={[MeetingType.Appraisal, MeetingType.AppraisalUpdate].includes(meetingOption) && shouldDisableAppraisals}
                    data-e2e-meeting-invite-option={meetingOption}
                  >
                    {t(`meetingTypes.${meetingOption}`)}
                  </Option>
                )
              })}
          </Select>
        </>
      )}
    </>
  )
}
